<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
#app {
  font-family: 'Norwester', sans-serif;
  text-align: center;
  height: 100%;
}

html, body {
  margin: 0;
  padding: 0;
  height: 100%;
}

</style>
